import Vue from 'vue'
import {helpers} from "../../helpers";

export default {
    store: {
        namespaced: true,
        state: {
            zones: [],
            zone: {},
            cities: [],
            city: {},
            discounts: [],
            discount: {},
            prices: [],
            price: {},
            prices_amount: 0,
            currentPricesPage: 0,
            extrasizes: [],

            luws_amount: 0,
            luws: [],
            luw: {},

            airports_amount: 0,
            airports: [],
            airport: {},

            airport_luws_amount: 0,
            airport_luws: [],
            airport_luw: {},

            manipulator_prices_amount: 0,
            manipulator_prices: [],
            manipulator_price: {},

            storage_prices_amount: 0,
            storage_prices: [],
            storage_price: {},

            storage_dates_amount: 0,
            storage_dates: [],
            storage_date: {},

            forwarding_prices: [],
            forwarding_price: {},
            forwarding_prices_amount: 0,

            doom_prices: [],
            doom_prices_amount: 0,

            additional_services: [],
            additional_service: {
                values: [],
            },

            additional_services_prices_amount: 0,
            additional_services_prices: [],
            additional_services_price: {},

            payment_methods: [],
            payment_methods_amount: 50,
            currentPaymentMethodPage: 1,
        },
        mutations: {
            setCurrentPricesPage(state, page) {
                if (page) state.currentPricesPage = page;
            },
            unshiftPrice(state, price) {
                state.prices.unshift(Object.assign({}, price));
            },
            unshiftForwardingPrice(state, price) {
                state.forwarding_prices.unshift(Object.assign({}, price));
            }
        },
        actions: {
            //подсказка адреса
            suggestStreet({ rootState }, data) {
                data = {
                    type:       'address',
                    from_bound: 'street',
                    to_bound:   'street',
                    bounds:     'street',
                    count:     data.count     ? data.count     : 10,
                    query:     data.string    ? data.string    : null,
                    locations: data.locations ? data.locations : null,
                };
                return helpers.http.get({context: this, rootState}, '/suggest', {params: data}).then(r => {
                    let result = [];
                    if (r instanceof Array) result = r;
                    else result.push(r);
                    return result;
                });
            },

            //подсказка адреса
            suggestCity({ rootState }, data) {
                data = {
                    type:       'address',
                    from_bound: 'city',
                    to_bound:   'settlement',
                    count: data.count  ? data.count  : 10,
                    query: data.string ? data.string : null
                };
                return helpers.http.get({context: this, rootState}, '/suggest', {params: data}).then(r => {
                    let result = [];
                    if (r instanceof Array) result = r;
                    else result.push(r);
                    return result;
                });
            },

            //получение зон
            getZones({ state, rootState }, data) {
                data = helpers.db.resolveGetParams(data);
                return helpers.http.get({context: this, rootState}, '/zone', {params: data}).then(r => {
                    Vue.set(state, 'zones', r.data)
                    Vue.set(state, 'zones_amount', r.total)
                    return r.data;
                });
            },

            suggestZones({ rootState }, search) {
                let data = {
                    page:  1,
                    count: 10,
                    order_by:   'created_at',
                    order_type: 'desc',
                    filter:     {model: [['name', '%', search]], relation: []},
                };
                data = helpers.db.resolveGetParams(data);
                return helpers.http.get({context: this, rootState}, '/zone', {params: data});
            },

            //получение зоны
            getZone({ state, rootState }, options) {
                return helpers.http.get({context: this, rootState}, '/zone/byid/' + options.id).then(r => {
                    Vue.set(state, 'zone', r);
                    return r;
                });
            },

            //добавление зоны
            addZone({ rootState }, data) {
                return helpers.http.post({context: this, rootState}, '/zone', data);
            },

            //обновление зоны
            updateZone({ rootState }, data) {
                return helpers.http.put({context: this, rootState}, '/zone', data);
            },

            //удаление зоны
            deleteZone({ rootState }, data) {
                return helpers.http.delete({context: this, rootState}, '/zone/byid/' + data);
            },

            getCitiesByZone({ rootState }, zoneId) {
                return helpers.http.get({context: this, rootState}, '/zone/byid/' + zoneId + '/cities');
            },

            deleteCityFromZone({ rootState }, data) {
                return helpers.http.delete({context: this, rootState}, '/zone/byid/' + data.zone_id + '/cities/' + data.city_id);
            },

            addCityToZone({ rootState }, data) {
                return helpers.http.post({context: this, rootState}, '/zone/byid/' + data.zone_id + '/cities/' + data.city_id);
            },

            addCitiesToZone({ rootState }, data) {
                return helpers.http.post({context: this, rootState}, '/zone/byid/' + data.zone_id + '/cities', data);
            },

            //получение городов
            getCitiesNew({ rootState }, data) {
                data = helpers.db.resolveGetParams(data);
                return helpers.http.get({context: this, rootState}, '/city', {params: data});
            },

            //получение городов
            getCities({ state, rootState }, data) {
                data = helpers.db.resolveGetParams(data);
                return helpers.http.get({context: this, rootState}, '/city', {params: data}).then(r => {
                    if (!r || !r.data) return [];
                    Vue.set(state, 'cities', r.data);
                    Vue.set(state, 'cities_amount', r.total);
                    return r.data;
                });
            },

            //получение города
            getCity({ state, rootState }, id) {
                return helpers.http.get({context: this, rootState}, '/city/byid/' + id).then(r => {
                    Vue.set(state, 'city', r);
                    return r;
                });
            },

            //добавление города
            addCity({ rootState }, data) {
                return helpers.http.post({context: this, rootState}, '/city', data);
            },

            //обновление города
            updateCity({ rootState }, data) {
                return helpers.http.put({context: this, rootState}, '/city', data);
            },

            //удаление города
            deleteCity({ rootState }, options) {
                return helpers.http.delete({context: this, rootState}, '/city/byid/' + options.id);
            },

            //получение цен на дополнительные услуги
            getAdditionalServicesPrices({ state, rootState }, data) {
                data = helpers.db.resolveGetParams(data);
                return helpers.http.get({context: this, rootState}, '/cost/additional-servces-price', {params: data}).then(r => {
                    if (!r || !r.data) return [];
                    Vue.set(state, 'additional_services_prices', r.data);
                    Vue.set(state, 'additional_services_prices_amount', r.total);
                    return r.data;
                });
            },

            //получение цены на дополнительные услуги
            getAdditionalServicesPriceId({ state, rootState }, id) {
                return helpers.http.get({context: this, rootState}, '/cost/additional-servces-price/byid/' + id).then(r => {
                    Vue.set(state, 'additional_services_price', r);
                    return r;
                });
            },

            //добавление цены на дополнительные услуги
            postAdditionalServicesPrice({ rootState }, data) {
                return helpers.http.post({context: this, rootState}, '/cost/additional-servces-price', data);
            },

            //обновление цены на дополнительные услуги
            putAdditionalServicesPrice({ rootState }, data) {
                return helpers.http.put({context: this, rootState}, '/cost/additional-servces-price', data);
            },

            //удаление цены на дополнительные услуги
            deleteAdditionalServicesPrice({ rootState }, id) {
                return helpers.http.delete({context: this, rootState}, '/cost/additional-servces-price/byid/' + id);
            },

            //получение цен на "Представление интересов в аэропорту"
            getAirports({ state, rootState }, data) {
                data = helpers.db.resolveGetParams(data);
                return helpers.http.get({context: this, rootState}, '/cost/airport-price', {params: data}).then(r => {
                    if (!r || !r.data) return [];
                    Vue.set(state, 'airports', r.data);
                    Vue.set(state, 'airports_amount', r.total);
                    return r.data;
                });
            },

            //получение цены на "Представление интересов в аэропорту"
            getAirport({ state, rootState }, id) {
                return helpers.http.get({context: this, rootState}, '/cost/airport-price/byid/' + id).then(r => {
                    Vue.set(state, 'airport', r);
                    return r;
                });
            },

            //добавление цены на "Представление интересов в аэропорту"
            postAirport({ rootState }, data) {
                return helpers.http.post({context: this, rootState}, '/cost/airport-price', data);
            },

            //обновление цены на "Представление интересов в аэропорту"
            putAirport({ rootState }, data) {
                return helpers.http.put({context: this, rootState}, '/cost/airport-price', data);
            },

            //удаление цены на "Представление интересов в аэропорту"
            deleteAirport({ rootState }, id) {
                return helpers.http.delete({context: this, rootState}, '/cost/airport-price/byid/' + id);
            },

            //получение цен на "ПРР в аэропорту"
            getAirportLuws({ state, rootState }, data) {
                data = helpers.db.resolveGetParams(data);
                return helpers.http.get({context: this, rootState}, '/cost/airport-luw-price', {params: data}).then(r => {
                    if (!r || !r.data) return [];
                    Vue.set(state, 'airport_luws', r.data);
                    Vue.set(state, 'airport_luws_amount', r.total);
                    return r.data;
                });
            },

            //получение цены на "ПРР в аэропорту"
            getAirportLuw({ state, rootState }, id) {
                return helpers.http.get({context: this, rootState}, '/cost/airport-luw-price/byid/' + id).then(r => {
                    Vue.set(state, 'airport_luw', r);
                    return r;
                });
            },

            //добавление цены на "ПРР в аэропорту"
            postAirportLuw({ rootState }, data) {
                return helpers.http.post({context: this, rootState}, '/cost/airport-luw-price', data);
            },

            //обновление цены на "ПРР в аэропорту"
            putAirportLuw({ rootState }, data) {
                return helpers.http.put({context: this, rootState}, '/cost/airport-luw-price', data);
            },

            //удаление цены на "ПРР в аэропорту"
            deleteAirportLuw({ rootState }, id) {
                return helpers.http.delete({context: this, rootState}, '/cost/airport-luw-price/byid/' + id);
            },

            //получение цен на ПРР
            getLuws({ state, rootState }, data) {
                data = helpers.db.resolveGetParams(data);
                return helpers.http.get({context: this, rootState}, '/cost/luw-price', {params: data}).then(r => {
                    if (!r || !r.data) return [];
                    Vue.set(state, 'luws', r.data);
                    Vue.set(state, 'luws_amount', r.total);
                    return r.data;
                });
            },

            //получение цены на ПРР
            getLuw({ state, rootState }, id) {
                return helpers.http.get({context: this, rootState}, '/cost/luw-price/byid/' + id).then(r => {
                    Vue.set(state, 'luw', r);
                    return r;
                });
            },

            //получение цены на ПРР для города/региона по id города
            getLuwByCityId({ rootState }, CityId) {
                return helpers.http.get({context: this, rootState}, '/cost/luw-price/bycity/' + CityId);
            },

            //получение цены на ПРР для города/региона по fias
            getLuwByCityFias({ rootState }, CityFias) {
                return helpers.http.get({context: this, rootState}, '/cost/luw-price/byfias/' + CityFias);
            },

            //добавление цены на ПРР
            postLuw({ rootState }, data) {
                return helpers.http.post({context: this, rootState}, '/cost/luw-price', data);
            },

            //обновление цены на ПРР
            putLuw({ rootState }, data) {
                return helpers.http.put({context: this, rootState}, '/cost/luw-price', data);
            },

            //удаление цены на ПРР
            deleteLuw({ rootState }, id) {
                return helpers.http.delete({context: this, rootState}, '/cost/luw-price/byid/' + id);
            },


            //получение цен на услуги манипулятора
            getManipulatorPrices({ state, rootState }, data) {
                data = helpers.db.resolveGetParams(data);
                return helpers.http.get({context: this, rootState}, '/cost/manipulator-price', {params: data}).then(r => {
                    if (!r || !r.data) return [];
                    Vue.set(state, 'manipulator_prices', r.data);
                    Vue.set(state, 'manipulator_proces_amount', r.total);
                    return r.data;
                });
            },

            //получение цены на услуги манипулятора
            getManipulatorPrice({ state, rootState }, id) {
                return helpers.http.get({context: this, rootState}, '/cost/manipulator-price/byid/' + id).then(r => {
                    Vue.set(state, 'manipulator', r);
                    return r;
                });
            },

            // поиск цена на услуги манипулятора по параметрам груза и заявки
            suggestManipulatorPrice({ rootState }, data) {
                return helpers.http.get({context: this, rootState}, '/cost/manipulator-price/suggest', {params: data});
            },

            //добавление цены на услуги манипулятора
            postManipulatorPrice({ rootState }, data) {
                return helpers.http.post({context: this, rootState}, '/cost/manipulator-price', data);
            },

            //обновление цены на услуги манипулятора
            putManipulatorPrice({ rootState }, data) {
                return helpers.http.put({context: this, rootState}, '/cost/manipulator-price', data);
            },

            //удаление цены на ПРР
            deleteManipulatorPrice({ rootState }, id) {
                return helpers.http.delete({context: this, rootState}, '/cost/manipulator-price/byid/' + id);
            },            


            //получение цен на услуги манипулятора
            getStoragePrices({ state, rootState }, data) {
                data = helpers.db.resolveGetParams(data);
                return helpers.http.get({context: this, rootState}, '/cost/storage-price', {params: data}).then(r => {
                    if (!r || !r.data) return [];
                    Vue.set(state, 'storage_prices', r.data);
                    Vue.set(state, 'storage_proces_amount', r.total);
                    return r.data;
                });
            },

            //получение цены на услуги манипулятора
            getStoragePrice({ state, rootState }, id) {
                return helpers.http.get({context: this, rootState}, '/cost/storage-price/byid/' + id).then(r => {
                    Vue.set(state, 'storage', r);
                    return r;
                });
            },

            //добавление цены на услуги манипулятора
            postStoragePrice({ rootState }, data) {
                return helpers.http.post({context: this, rootState}, '/cost/storage-price', data);
            },

            //обновление цены на услуги манипулятора
            putStoragePrice({ rootState }, data) {
                return helpers.http.put({context: this, rootState}, '/cost/storage-price', data);
            },

            //удаление цены на ПРР
            deleteStoragePrice({ rootState }, id) {
                return helpers.http.delete({context: this, rootState}, '/cost/storage-price/byid/' + id);
            },            



            //добавление даты для услуги манипулятора
            postStorageDate({ rootState }, data) {
                return helpers.http.post({context: this, rootState}, '/cost/storage-date', data);
            },
            //удаление даты для услуги манипулятора
            deleteStorageDate({ rootState }, data) {
                return helpers.http.delete({context: this, rootState}, '/cost/storage-date', { params: data });
            },
            //получение дат для услуги манипулятора
            getStorageDates({ state, rootState }, data) {
                data = helpers.db.resolveGetParams(data);
                return helpers.http.get({context: this, rootState}, '/cost/storage-date', {params: data}).then(r => {
                    if (!r || !r.data) return [];
                    Vue.set(state, 'storage_dates', r.data);
                    Vue.set(state, 'storage_dates_amount', r.total);
                    return r.data;
                });
            },
            


            //получение скидок
            getDiscounts({ state, rootState }, data) {
                data = helpers.db.resolveGetParams(data);
                return helpers.http.get({context: this, rootState}, '/cost/discount', {params: data}).then(r => {
                    if (!r || !r.data) return [];
                    let discounts = r.data || r;
                    Vue.set(state, 'discounts', discounts);
                    Vue.set(state, 'discounts_amount', r.total);
                });
            },

            //получение скидки
            getDiscount({ state, rootState, dispatch }, options) {
                return helpers.http.get({context: this, rootState}, '/cost/discount/byid/' + options.id).then(discount => {
                    return dispatch('customers/getCustomerGroup', { id: discount.customers_group_id }).then(group => {
                        discount.customers_group = group;
                        Vue.set(state, 'discount', discount);
                        return discount;
                    });
                });
            },

            //добавление скидки
            addDiscount({ rootState }, data) {
                return helpers.http.post({context: this, rootState}, '/cost/discount', data.discount);
            },

            //обновление скидки
            updateDiscount({ rootState }, data) {
                return helpers.http.put({context: this, rootState}, '/cost/discount', data.discount);
            },

            //удаление скидки
            deleteDiscount({ rootState }, data) {
                return helpers.http.delete({context: this, rootState}, '/cost/discount/byid/' + data.id);
            },

            //получение цен из города в город
            getPrices({ state, rootState }, data) {
                data = helpers.db.resolveGetParams(data);
                return helpers.http.get({context: this, rootState}, '/cost/price', {params: data}).then(r => {
                    Vue.set(state, 'prices', r.data)
                    Vue.set(state, 'prices_amount', r.total)
                    return r;
                });
            },

            //получение цены
            getPrice({ state, rootState }, options) {
                return helpers.http.get({context: this, rootState}, '/cost/price/byid/' + options.id).then(r => {
                    Vue.set(state, 'price', r);
                    return r;
                });
            },

            //сохранение цены
            addPrice({ rootState }, data) {
                return helpers.http.post({context: this, rootState}, '/cost/price', data.price);
            },

            //обновление цены
            updatePrice({ rootState }, data) {
                return helpers.http.put({context: this, rootState}, '/cost/price', data.price);
            },

            //удаление цены
            deletePrice({ rootState }, options) {
                return helpers.http.delete({context: this, rootState}, '/cost/price/byid/' + options.id);
            },

            //получение цен
            getDoomPrices({ state, rootState }, data) {
                data = helpers.db.resolveGetParams(data);
                return helpers.http.get({context: this, rootState}, '/cost/doom-price', {params: data}).then(r => {
                    Vue.set(state, 'doom_prices', r.data)
                    Vue.set(state, 'doom_prices_amount', r.total)
                    return r;
                });
            },

            //получение цены
            getDoomPrice({ state, rootState }, data) {
                return helpers.http.get({context: this, rootState}, '/cost/doom-price/byid/' + data.id).then(r => {
                    Vue.set(state, 'doom_price', r);
                    return r;
                });
            },

            //сохранение цены
            postDoomPrice({ rootState }, data) {
                return helpers.http.post({context: this, rootState}, '/cost/doom-price', data);
            },

            //обновление цены
            putDoomPrice({ rootState }, data) {
                return helpers.http.put({context: this, rootState}, '/cost/doom-price', data);
            },

            //удаление цены
            deleteDoomPrice({ rootState }, data) {
                return helpers.http.delete({context: this, rootState}, '/cost/doom-price/byid/' + data);
            },





            //получение цен
            getForwardingPrices({ state, rootState }, data) {
                data = helpers.db.resolveGetParams(data);
                return helpers.http.get({context: this, rootState}, '/cost/forwarding_price', {params: data}).then(r => {
                    if (!r || !r.data) return [];
                    Vue.set(state, 'forwarding_prices', r.data);
                    Vue.set(state, 'forwarding_prices_amount', r.total);
                    return r;
                });
            },

            //получение цены
            getForwardingPrice({ state, rootState }, data) {
                return helpers.http.get({context: this, rootState}, '/cost/forwarding_price/byid/' + data.id).then(r => {
                    Vue.set(state, 'forwarding_price', r);
                    return r;
                });
            },

            //сохранение цены
            addForwardingPrice({ rootState }, data) {
                return helpers.http.post({context: this, rootState}, '/cost/forwarding_price', data.price);
            },

            //обновление цены
            updateForwardingPrice({ rootState }, data) {
                return helpers.http.put({context: this, rootState}, '/cost/forwarding_price', data.price);
            },

            //удаление цены
            deleteForwardingPrice({ rootState }, data) {
                return helpers.http.delete({context: this, rootState}, '/cost/forwarding_price/byid/' + data);
            },


            //получение вписка дополнительных услуг
            getAdditionalServices({ state, rootState }, data) {
                data = helpers.db.resolveGetParams(data);
                return helpers.http.get({context: this, rootState}, '/deals/services',  {params: data}).then(r => {
                    if (!r || !r.data) return [];
                    Vue.set(state, 'additional_services', r.data || r);
                    Vue.set(state, 'additional_services_amount', r.total);
                    return r.data || r;
                });
            },

            getAdditionalService({ state, rootState }, id) {
                return helpers.http.get({context: this, rootState}, '/deals/services/byid/' + id).then(r => {
                    Vue.set(state, 'additional_service', Object.assign({}, r));
                    return r;
                });
            },

            putAdditionalService({ rootState }, data) {
                return helpers.http.put({context: this, rootState}, '/deals/services', data);
            },
            postAdditionalService({ rootState }, data) {
                return helpers.http.post({context: this, rootState}, '/deals/services', data);
            },
            removeAdditionalService({ rootState }, id) {
                return helpers.http.delete({context: this, rootState}, '/deals/services/byid/' + id);
            },

            putServiceValue({ rootState }, data) {
                return helpers.http.put({context: this, rootState}, '/deals/services/values', data);
            },
            postServiceValue({ rootState }, data) {
                return helpers.http.post({context: this, rootState}, '/deals/services/values', data);
            },
            removeServiceValue({ rootState }, service_id) {
                return Vue.http.delete(rootState.endpoint + '/deals/services/values/byid/' + service_id);
            },

            //получение списка дополнительных услуг
            getExtrasizes({ state, rootState }, data) {
                data = helpers.db.resolveGetParams(data);
                return helpers.http.get({context: this, rootState}, '/deals/extrasize_settings', {params: data}).then(r => {
                    if (!r || !r.data) return [];
                    Vue.set(state, 'extrasizes', r.data);
                    Vue.set(state, 'extrasizes_amount', r.total);
                    return r;
                });
            },

            getExtrasize({ state, rootState }, data) {
                return helpers.http.get({context: this, rootState}, '/deals/extrasize_settings/byid/' + data.id, data).then(r => {
                    Vue.set(state, 'extrasize', r);
                    return r;
                });
            },

            putExtrasize({ rootState }, data) {
                return helpers.http.put({context: this, rootState}, '/deals/extrasize_settings', data);
            },
            postExtrasize({ rootState }, data) {
                return helpers.http.post({context: this, rootState}, '/deals/extrasize_settings', data);
            },
            removeExtrasize({ rootState }, id) {
                return helpers.http.delete({context: this, rootState}, '/deals/extrasize_settings/byid/' + id);
            },


            getPaymentMethods({ state, rootState }, data) {
                data = helpers.db.resolveGetParams(data);
                return helpers.http.get({context: this, rootState}, '/cost/payment_method', {params: data}).then(r => {
                    if (!r || !r.data) return [];
                    Vue.set(state, 'payment_methods', r.data);
                    Vue.set(state, 'payment_methods_amount', r.total);
                    return r.data;
                });
            },

            getPaymentMethod({ rootState }, id) {
                return helpers.http.get({context: this, rootState}, '/cost/payment_method/byid/' + id);
            },

            postPaymentMethod({ rootState }, data) {
                return helpers.http.post({context: this, rootState}, '/cost/payment_method', data);
            },

            putPaymentMethod({ rootState }, data) {
                return helpers.http.put({context: this, rootState}, '/cost/payment_method', data);
            },

            deletePaymentMethod({ rootState }, id) {
                return helpers.http.delete({context: this, rootState}, '/cost/payment_method/byid/' + id);
            },

            getCostParam({ rootState }, code) {
                return helpers.http.get({context: this, rootState}, `/cost/param/${code}`);
            },
        }
    }
}



// WEBPACK FOOTER //
// ./src/modules/cost/store.js